import script from "./PatientCallingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientCallingModal.vue?vue&type=script&setup=true&lang=js"

import "./PatientCallingModal.vue?vue&type=style&index=0&id=5a7c97ed&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a7c97ed"]])

export default __exports__